import { render, staticRenderFns } from "./tst.vue?vue&type=template&id=63834abb"
import script from "./tst.vue?vue&type=script&lang=ts"
export * from "./tst.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports